import React, { CSSProperties } from 'react';

interface SpacerProps {
    spacing: number;
    style?: CSSProperties;
}

const Spacer: React.FC<SpacerProps> = ({ spacing, style }) => {
    return (
        <div
            style={{
                width: `${spacing}px`,
                height: `${spacing}px`,
                flexShrink: 0,
                ...(style ?? {}),
            }}
        />
    );
};

export default Spacer;
